export class Periodicity {
  value = 0;
  type = '';
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/periodicity.ts